var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"px-4 py-3 mt-sm-n4 pr-sm-0"},[_c('p',{staticClass:"credits text-right small",domProps:{"innerHTML":_vm._s(_vm.$t('credits', {
      author: '<a href=\'http://www.davidrevoy.com\'>David Revoy</a>'
    }))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }